import UpgradeModal from '../UpgradeModal';
import useUpgradeModal from 'hooks/useUpgradeModal';
import { useNavigate } from 'react-router-dom';
import { PAGE_PATHS } from 'config/routes';
import { useTrackEvent } from 'utils/tracking/hooks';

interface EssentialUpgradeProps {
  canLoadBanner: boolean;
}

const EssentialUpgrade: React.FC<EssentialUpgradeProps> = ({
  canLoadBanner,
}) => {
  const navigate = useNavigate();
  const { trackCtaClick } = useTrackEvent();

  const { open, onClose } = useUpgradeModal({
    canLoadBanner,
  });

  if (!open) {
    return null;
  }

  const handleReadMore = () => {
    onClose();
    navigate(PAGE_PATHS.MY_ACCOUNT.SPECIAL_OFFER_PAGE);
  };
  const handleUpgradeNow = () => {
    trackCtaClick('essential to smart', 'essential to smart pop up');
    onClose();
    navigate(PAGE_PATHS.MY_ACCOUNT.SPECIAL_OFFER_PAGE); // @todo - add the correct path
  };

  return (
    <UpgradeModal
      onReadMore={handleReadMore}
      onUpgradeNow={handleUpgradeNow}
      onClose={onClose}
    />
  );
};

export default EssentialUpgrade;
